// import React, { useEffect, useState } from "react";

// export default function EditDraftModal({ draft, onSave, onClose }) {
//   const [formData, setFormData] = useState({ title: "", description: "", url: "" });

//   useEffect(() => {
//     if (draft) {
//       setFormData({
//         title: draft.title,
//         description: draft.description || "",
//         url: draft.url || "",
//       });
//     }
//   }, [draft]);

//   if (!draft) return null;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const finalData = {
//       ...formData,
//       url: formData.url || "https://evindia.online",
//     };
//     onSave({ ...draft, ...finalData });
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
//       <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-full overflow-y-auto">
//         <div className="p-6">
//           <div className="flex justify-between items-center mb-4">
//             <h2 className="text-2xl font-bold text-gray-800">Edit Notification</h2>
//             <button
//               onClick={onClose}
//               className="text-gray-400 hover:text-gray-600 text-3xl leading-none"
//             >
//               &times;
//             </button>
//           </div>
//           <form onSubmit={handleSubmit} className="space-y-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Title
//               </label>
//               <input
//                 type="text"
//                 name="title"
//                 value={formData.title}
//                 onChange={handleChange}
//                 className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#FDBF00] focus:border-[#FDBF00]"
//                 required
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Description
//               </label>
//               <textarea
//                 name="description"
//                 value={formData.description}
//                 onChange={handleChange}
//                 rows="4"
//                 className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#FDBF00] focus:border-[#FDBF00]"
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 URL
//               </label>
//               <input
//                 type="url"
//                 name="url"
//                 value={formData.url}
//                 onChange={handleChange}
//                 placeholder="https://example.com"
//                 className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#FDBF00] focus:border-[#FDBF00]"
//               />
//               <p className="text-xs text-gray-500 mt-1">
//                 If left blank, defaults to https://evindia.online
//               </p>
//             </div>

//             <div className="mt-6 flex justify-end gap-3">
//               <button
//                 type="button"
//                 onClick={onClose}
//                 className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="px-4 py-2 bg-[#FDBF00] text-black rounded-lg font-semibold hover:bg-[#E4AB00]"
//               >
//                 Save Changes
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Textarea,
} from "@heroui/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotificationDetails, editNotification } from "../../../redux/slices/notificationsSlice";


export default function EditDraftModal({ draft, onSave, onClose }) {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    url: "",
  });

  const dispatch = useDispatch();
  const { status } = useSelector((s) => s.notifications);

  // useEffect(() => {
  //   if (draft) {
  //     setFormData({
  //       title: draft.title,
  //       description: draft.description || "",
  //       url: draft.url || "",
  //     });
  //   }
  // }, [draft]);

  // if (!draft) return null;


  useEffect(() => {
    if (draft?.id) {
      // Fetch latest details from backend
      dispatch(fetchNotificationDetails(draft.id))
        .unwrap()
        .then((data) => {
          setFormData({
            title: data.title || "",
            description: data.description || "",
            url: data.link || "",
          });
        })
        .catch(() => {
          // fallback to existing draft data
          setFormData({
            title: draft.title || "",
            description: draft.description || "",
            url: draft.url || "",
          });
        });
    } else if (draft) {
      // For mock data fallback
      setFormData({
        title: draft.title,
        description: draft.description || "",
        url: draft.url || "",
      });
    }
  }, [draft, dispatch]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const finalData = {
  //     ...formData,
  //     url: formData.url || "https://evindia.online",
  //   };
  //   onSave({ ...draft, ...finalData });
  // };

  const handleSubmit = async (e) => {
    const payload = {
      title: formData.title,
      description: formData.description,
      link: formData.url || "https://evindia.online",
    };

    try {
      const res = await dispatch(
        editNotification({ id: draft._id || draft.id, data: payload })
      ).unwrap();

      onSave(res); // updates Redux locally too
      onClose();
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };


  return (
    <Modal isOpen onOpenChange={onClose} backdrop="blur" size="2xl">
      <ModalContent className="bg-white rounded-lg shadow-2xl">
        <ModalHeader className="flex justify-between items-center">
          <h2 className="text-2xl font-bold text-gray-800">
            Edit Notification
          </h2>
        </ModalHeader>

        <ModalBody>
          <div className="space-y-4">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Title
              </label>
              <Input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                className="w-full shadow-sm rounded-md focus:ring-[#FDBF00] focus:border-[#FDBF00]"
                required
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <Textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                className="w-full shadow-sm rounded-md focus:ring-[#FDBF00] focus:border-[#FDBF00]"
                rows={6}
                style={{ resize: "vertical" }}
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                URL
              </label>
              <Input
                type="url"
                name="url"
                value={formData.url}
                onChange={handleChange}
                placeholder="https://example.com"
                className="w-full shadow-sm rounded-md focus:ring-[#FDBF00] focus:border-[#FDBF00]"
              />
              <p className="text-xs text-gray-500 mt-1">
                If left blank, defaults to https://evindia.online
              </p>
            </div>
          </div>
        </ModalBody>

        <ModalFooter className="flex justify-end gap-3">
          <Button
            variant="flat"
            color="default"
            onPress={onClose}
          >
            Cancel
          </Button>
          <Button
            color="warning"
            isLoading={status.edit === "loading"}
            className="px-4 py-2 bg-button text-white rounded-lg font-semibold"
            onPress={handleSubmit}

          >
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
